import { useCallback } from 'react'

import ImportModal, { ImportModalProps } from 'components/ImportModal/ImportModal'
import { useModals } from 'almanac-ui/Modal'

export const useImportModal = () => {
  const { openModal, closeModal } = useModals()

  const openImportModal = useCallback(
    (props?: ImportModalProps) => {
      openModal(ImportModal, {
        ...props,
        onClose: closeModal,
        onGoBack: closeModal
      })
    },
    [openModal, closeModal],
  )

  return {
    openImportModal,
  }
}

export default useImportModal
